import React, { useState } from 'react';

interface AuthModalProps {
  isOpen: boolean;
  onSteamLogin: () => void;
  error?: string;
}

const AuthModal: React.FC<AuthModalProps> = ({ isOpen, onSteamLogin, error }) => {
  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 10000,
      backdropFilter: 'blur(5px)'
    }}>
      <div style={{
        backgroundColor: '#1e1e1e',
        borderRadius: '12px',
        padding: '40px',
        maxWidth: '400px',
        width: '90%',
        textAlign: 'center',
        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.5)',
        border: '1px solid #333',
        position: 'relative'
      }}>
        {/* Steam Logo */}
        <div style={{ marginBottom: '20px' }}>
          <div style={{
            width: '60px',
            height: '60px',
            backgroundColor: '#171a21',
            borderRadius: '50%',
            margin: '0 auto 15px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '2px solid #66c0f4'
          }}>
            <span style={{ 
              fontSize: '24px', 
              color: '#66c0f4',
              fontWeight: 'bold'
            }}>S</span>
          </div>
        </div>

        <h2 style={{
          color: '#ffffff',
          margin: '0 0 10px 0',
          fontSize: '24px',
          fontWeight: '600'
        }}>
          Authentication
        </h2>
        
        <p style={{
          color: '#b8b8b8',
          margin: '0 0 30px 0',
          fontSize: '14px',
          lineHeight: '1.5'
        }}>
          {/* Log in with your one of the methods below. */}
        </p>
        
        {error && (
          <div style={{
            backgroundColor: '#ff4444',
            color: '#ffffff',
            padding: '12px 16px',
            borderRadius: '6px',
            margin: '0 0 20px 0',
            fontSize: '14px',
            border: '1px solid #cc0000',
            whiteSpace: 'pre-line'
          }}>
            {error}
          </div>
        )}
        
        <button 
          onClick={onSteamLogin} 
          style={{
            backgroundColor: 'transparent',
            border: 'none',
            cursor: 'pointer',
            padding: '0',
            margin: '0 auto 20px',
            transition: 'transform 0.2s ease',
            display: 'block'
          }}
          onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
          onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
        >
          <img 
            src="https://steamcommunity-a.akamaihd.net/public/images/signinthroughsteam/sits_01.png" 
            alt="Sign in through Steam"
            style={{ 
              width: '180px', 
              height: '35px',
              borderRadius: '4px'
            }}
          />
        </button>
        
        <div style={{
          backgroundColor: '#2a2a2a',
          padding: '15px',
          borderRadius: '6px',
          border: '1px solid #404040'
        }}>
          <p style={{ 
            fontSize: '12px', 
            color: '#888',
            margin: '0',
            lineHeight: '1.4'
          }}>
            <strong style={{ color: '#66c0f4' }}>Only whitelisted users can access. <br />
            Contact an administrator if you need access.</strong>
          </p>
        </div>

        {/* Decorative elements */}
        <div style={{
          position: 'absolute',
          top: '-2px',
          left: '-2px',
          right: '-2px',
          bottom: '-2px',
          background: 'linear-gradient(45deg, #66c0f4, #1e90ff, #66c0f4)',
          borderRadius: '14px',
          zIndex: -1,
          opacity: 0.3
        }} />
      </div>
    </div>
  );
};

export default AuthModal; 